module.exports = __webpack_public_path__ + "static/img/P7.ff15cbd8.png";